
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAnchorIec as ObiAnchorIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-anchor-iec.js';
 
 
 

 
 export const ObiAnchorIec = createComponent({
   react: React,
   tagName: 'obi-anchor-iec',
   elementClass: ObiAnchorIecElement,
   events: {
     
   }
  });
 
 